import dagre from 'dagre';

// Mismas medidas que `.ui-tree__node`: si dagre reserva menos, los nodos se
// tocan y las aristas cruzan por encima de las tarjetas.
const nodeWidth = 158;
const nodeHeight = 96;

export const getLayoutedElements = (nodes, edges, direction = 'TB') => {
  // El grafo se crea en cada llamada. Cuando era de módulo, los nodos de un
  // despliegue anterior seguían dentro: al plegar una subred, dagre seguía
  // reservándoles sitio y el árbol quedaba con huecos que no correspondían a
  // ningún nodo visible.
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({ rankdir: direction, nodesep: 28, ranksep: 62 });

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const layoutedNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id);
    if (nodeWithPosition) {
      node.position = {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      };
    }
    return node;
  });

  return { nodes: layoutedNodes, edges };
};
